import React, { useEffect, useState } from "react";
import Pencil from "../../../../images/pencil.png";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { setProfessionalInfo } from "../../../../features/candidate/personalSlice";
import { mapToOption } from "../../../../utlis";
import useFetch from "../../../../hooks/useFetch";
import { useCandidateForm } from "../../CandidateFormContext";
import { toast } from "react-toastify";

const Professional = () => {
  const { data: refSalesPerson, loading } = useFetch('/salesteam')

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { isCreating, markTabComplete, hasUnsavedChanges, isSaving, saveAllChanges } = useCandidateForm();
  const {
    jobTitle,
    salesPerson,
    technology,
    workPermitStatus,
    workStatusIssueDate,
    workStatusEndDate,
    SSN,
    employmentStatus,
    referredBy,
  } = useSelector((state) => state.personal.professional);

  const referenceData = useSelector((state) => state.reference);

  const [professionalData, setProfessionalData] = useState({
    jobTitle,
    salesPerson,
    technology,
    workPermitStatus,
    workStatusIssueDate,
    workStatusEndDate,
    SSN,
    employmentStatus,
    referredBy,
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setProfessionalData((pervData) => {
      const updated = { ...pervData, [name]: value };
      // Clear work permit dates when US Citizen is selected
      if (name === 'workPermitStatus' && value === 'US Citizen') {
        updated.workStatusIssueDate = '';
        updated.workStatusEndDate = '';
      }
      return updated;
    });
  };

  const isUSCitizen = professionalData.workPermitStatus === 'US Citizen';

  useEffect(() => {
    dispatch(setProfessionalInfo(professionalData));
  }, [professionalData]);

  // Format date for input (YYYY-MM-DD)
  const formatDateForInput = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return dateString;
    return date.toISOString().split('T')[0];
  };

  // Validate required fields
  const validateProfessionalInfo = () => {
    const requiredFields = [
      { field: 'jobTitle', label: 'Job Title' },
      { field: 'salesPerson', label: 'Sales Person' },
      { field: 'technology', label: 'Technology' },
      { field: 'workPermitStatus', label: 'Work Permit Status' },
    ];

    for (const { field, label } of requiredFields) {
      if (!professionalData[field] || professionalData[field].toString().trim() === '') {
        toast.error(`${label} is required`);
        return false;
      }
    }
    return true;
  };

  // Handle Previous button click
  const handlePrevious = () => {
    navigate('/candidate/add-candidate/personal/basic');
  };

  // Handle Next button click
  const handleNext = () => {
    // In create mode, validate before proceeding
    if (isCreating) {
      if (!validateProfessionalInfo()) {
        return;
      }
      // Mark tab as complete
      markTabComplete('professional');
    }
    // Navigate to next tab
    navigate('/candidate/add-candidate/personal/profile');
  };

  return (
    <div className="">
      <from className="flex flex-col gap-y-6 mt-5 text-sm font-normal text-text-hint">
        <div className="grid grid-cols-4 gap-3">
          <div className="">
            <label className="">
              Job Title<span className="text-red-500">*</span>
            </label>
            <select
              onChange={handleChange}
              name="jobTitle"
              value={jobTitle}
              className="flex justify-center items-center text-black focus:ring-0 px-3 py-2 mt-1 border border-neutral-500 rounded-lg outline-none w-full"
            >
              {mapToOption(referenceData.jobtitles?.job || [], 'title').map((option) => (
                <option key={option.value} value={option.value}>
                  {option.text}
                </option>
              ))}
            </select>
          </div>
          <div className="">
            <label className="">
              Sales Person<span className="text-red-500">*</span>
            </label>
            <select
              onChange={handleChange}
              name="salesPerson"
              value={salesPerson}
              className="flex justify-center items-center text-black focus:ring-0 px-3 py-2 mt-1 border border-neutral-500 rounded-lg outline-none w-full"
            >
              {!loading && mapToOption(refSalesPerson?.data?.records || [], 'first_name', 'sales_person_id').map((option) => (
                <option className="" key={option.value} value={option.value}>
                  {option.text}
                </option>
              ))}
            </select>
          </div>
        </div>
        <div className="grid grid-cols-4 gap-3">
          <div>
            <label>
              Technology<span className="text-red-500">*</span>
            </label>
            <select
              onChange={handleChange}
              name="technology"
              value={technology}
              className="flex justify-center items-center text-black focus:ring-0 px-3 py-2 mt-1 border border-neutral-500 rounded-lg outline-none w-full"
            >
              {mapToOption(referenceData.technologies?.technology || [], 'description', 'technology_id').map((option, i) => (
                <option key={`${option.value}_${i + 1}`} value={option.value}>
                  {option.text}
                </option>
              ))}
            </select>
          </div>
        </div>
        <div className="grid grid-cols-4 gap-3">
          <div className="">
            <label className="">
              Work Permit Status<span className="text-red-500">*</span>
            </label>
            <select
              onChange={handleChange}
              name="workPermitStatus"
              value={workPermitStatus}
              className="flex justify-center items-center text-black focus:ring-0 px-3 py-2 mt-1 border border-neutral-500 rounded-lg outline-none w-full"
            >
              {mapToOption(referenceData.legalstatuses?.legal || [], 'status').map((option) => (
                <option key={option.value} value={option.value}>
                  {option.text}
                </option>
              ))}
            </select>

          </div>
        </div>
        {!isUSCitizen && (
        <div className="grid grid-cols-4 gap-3">
          <div className="max-w-xs">
            <label className="">
              Work Permit Issue Date<span className="text-red-500">*</span>
            </label>
            <div className="flex justify-center items-center px-3 py-2 mt-1 border border-neutral-500 rounded-lg h-10">
              <input
                onChange={handleChange}
                value={formatDateForInput(workStatusIssueDate)}
                name="workStatusIssueDate"
                type="date"
                required
                className="outline-none border-none w-full text-black bg-transparent"
              />
            </div>
          </div>
          <div className="max-w-xs">
            <label className="">
              Work Permit Expire Date<span className="text-red-500">*</span>
            </label>
            <div className="flex justify-center items-center px-3 py-2 mt-1 border border-neutral-500 rounded-lg h-10">
              <input
                onChange={handleChange}
                value={formatDateForInput(workStatusEndDate)}
                name="workStatusEndDate"
                type="date"
                required
                className="outline-none border-none w-full text-black bg-transparent"
              />
            </div>
          </div>
        </div>
        )}
        <div className="grid grid-cols-4 gap-3">
          <div className="">
            <label className="">
              SSN<span className="text-red-500">*</span>
            </label>
            <div className="flex justify-center items-center px-3 py-2 mt-1 border border-neutral-500 rounded-lg h-10">
              <input
                onChange={handleChange}
                value={SSN}
                name="SSN"
                placeholder="SSN"
                required
                maxLength={11}
                className="outline-none w-full text-black"
              />
              <img src={Pencil} alt="pencil" />
            </div>
          </div>
        </div>
        <div className="grid grid-cols-4 gap-3">
          <div className="">
            <label className="">
              Employment Status<span className="text-red-500">*</span>
            </label>
            <select
              onChange={handleChange}
              name="employmentStatus"
              value={employmentStatus}
              className="flex justify-center items-center text-black focus:ring-0 px-3 py-2 mt-1 border border-neutral-500 rounded-lg outline-none w-full"
            >
              {mapToOption(referenceData.employmentstatuses?.employment || [], 'status').map((option) => (
                <option key={option.value} value={option.value}>
                  {option.text}
                </option>
              ))}
            </select>
          </div>
          <div className="">
            <label className="">
              Referred By
            </label>
            <div className="flex justify-center items-center px-3 py-2 mt-1 border border-neutral-500 rounded-lg h-10">
              <input
                onChange={handleChange}
                value={referredBy}
                name="referredBy"
                placeholder="Referred By"
                maxLength={25}
                className="outline-none w-full text-black"
              />
              <img src={Pencil} alt="pencil" />
            </div>
          </div>
        </div>
      </from>
      <div className="w-full py-10 px-8 flex justify-end gap-5">
        <button
          onClick={handlePrevious}
          className="text-secondary-700 bg-white border border-secondary-700 py-2 px-5 rounded-full text-base hover:bg-gray-50 transition"
        >
          Previous
        </button>
        {!isCreating && hasUnsavedChanges && (
          <button
            disabled={isSaving}
            onClick={async () => {
              try {
                await saveAllChanges();
              } catch (e) {
                // error toast handled by context
              }
            }}
            className="text-white bg-green-600 py-2 px-5 rounded-full text-base hover:bg-green-700 transition disabled:opacity-50"
          >
            {isSaving ? 'Saving...' : 'Save'}
          </button>
        )}
        <button
          onClick={handleNext}
          className="text-white bg-secondary-700 py-2 px-5 rounded-full text-base hover:bg-secondary-800 transition"
        >
          Next
        </button>
      </div>
    </div>
  );
};

export default Professional;
